import { getMptClubs, editMptClub, postMptClub } from '../../entities/mpt/clubs';

export const scope = 'MPT_CLUBS';

export function getClubs() {
    return (dispatch, getState) => {
        const { clubs } = getState().app.mpt;

        if (!clubs.info.isFetching)
          dispatch(getMptClubs(scope));
    };
}

export function editClub(payload) {
    return (dispatch, getState) => {
        const { clubs } = getState().app.mpt;

        if (!clubs.info.isFetching)
            dispatch(editMptClub(payload, scope));
    };
}

export function postClub(payload) {
    return (dispatch, getState) => {
        const { clubs } = getState().app.mpt;

        if (!clubs.info.isFetching)
            dispatch(postMptClub(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/mpt/clubs.js